<template>
  <div :class="{ [$style.cont]: !compact }" style="text-align: center;">
    <div :class="{ [$style.loaderCont]: !compact }">
      <div
        class="ui centered inline loader active workaround"
        :class="[size]"
      />
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'RgLoader',
  props: {
    compact: {
      type: Boolean,
      default: false
    },
    size: {
      type: String
    }
  }
}
</script>

<style>
.ui.dimmer .ui.workaround.loader::before {
  border-color: rgba(0, 0, 0, 0.1);
}

.ui.dimmer .ui.workaround.loader::after {
  border-color: #767676 transparent transparent;
}
</style>

<style module>
.cont {
  margin: 20px 0;
}

.loaderCont {
  margin: 12px 0;
}
</style>
